import { render, staticRenderFns } from "./specData.vue?vue&type=template&id=2195610b&scoped=true&"
import script from "./specData.vue?vue&type=script&lang=js&"
export * from "./specData.vue?vue&type=script&lang=js&"
import style0 from "./specData.vue?vue&type=style&index=0&id=2195610b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195610b",
  null
  
)

export default component.exports